module.exports = __webpack_public_path__ + "img/mobile-backend-and-apis-listing.bc41162c.jpg";